import { render, staticRenderFns } from "./Degree.vue?vue&type=template&id=325ced78&"
import script from "./Degree.vue?vue&type=script&lang=ts&"
export * from "./Degree.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports